// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__39A8X","col":"styles_col__34yJR","fulfillmentStatus":"styles_fulfillmentStatus__3RD2a","emailCol":"styles_emailCol__2tBzh"};